import { render, staticRenderFns } from "./guard.vue?vue&type=template&id=5fbee399"
import script from "./guard.vue?vue&type=script&lang=js"
export * from "./guard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports